import React from 'react'
import * as Styles from './styles'

type Props = {
  compact: boolean
  urlImage: string
  urlImageIcon: string
  alt?: boolean
}

const Logo: React.FC<any> = (props: Props) => {
  const image = props.urlImage
  const imageIcon = props.urlImageIcon
  const altTheme = `${props.alt ? 'is-alt' : ''}`

  return (
    <Styles.Logo className={altTheme}>
      <Styles.Image
        src={props.compact ? imageIcon : image}
        className={altTheme}
      />
    </Styles.Logo>
  )
}

export default Logo

Logo.defaultProps = {
  alt: false,
}
